import axios, { AxiosInstance } from 'axios';

// Public client — NO auth headers; the token in the URL is the auth.
const client: AxiosInstance = axios.create({
  baseURL: '',
  headers: { 'Content-Type': 'application/json' },
});

export interface PortalInfoView {
  customer: { first_name?: string; last_name?: string; email?: string; phone?: string };
  vehicle: { year?: number; make?: string; model?: string; vin?: string; mileage?: number };
}

export interface PortalEstimateView {
  estimate: any;
  customer: any;
  vehicle: any;
  line_items: Array<{ id: number; description: string; labor_hours: number; total_price: number; is_taxable: boolean; approval_status: string }>;
  fees: any[];
  photos: Array<{ id: number; file_path: string; sub_type: string }>;
  shop_name: string;
  dvi?: import('../../components/DVI/PortalDVISection').PortalDVIPayload | null;
}

export interface PortalWorkOrderView {
  work_order: any;
  customer: any;
  vehicle: any;
  line_items: any[];
  photos: any[];
}

export interface PortalInvoiceView {
  invoice: any;
  customer: any;
  vehicle: any;
  line_items: any[];
  fees: any[];
  /**
   * WP-10 slice 1 — the inspection behind this invoice. Optional because a
   * response cached or served before this slice will not carry it, and because
   * an invoice for work with no inspection legitimately has none.
   */
  inspection?: import('../../components/DVI/PortalDVISection').PortalDVIPayload | null;
}

export const portalApi = {
  getInfo: (token: string) =>
    client.get<PortalInfoView>(`/portal/info/${token}`).then((r) => r.data),
  submitInfo: (
    token: string,
    body: { customer: any; vehicle: any; condition_photo_attachment_ids?: number[] }
  ) => client.post(`/portal/info/${token}`, body).then((r) => r.data),
  getEstimate: (token: string) =>
    client.get<PortalEstimateView>(`/portal/estimate/${token}`).then((r) => r.data),
  approveEstimate: (
    token: string,
    body: {
      action: 'approve_selected' | 'approve_all' | 'decline_all';
      line_item_ids?: number[];
      signature_data_url: string;
    }
  ) => client.post(`/portal/estimate/${token}/approve`, body).then((r) => r.data),
  getWorkOrder: (token: string) =>
    client.get<PortalWorkOrderView>(`/portal/workorder/${token}`).then((r) => r.data),
  getInvoice: (token: string) =>
    client.get<PortalInvoiceView>(`/portal/invoice/${token}`).then((r) => r.data),
  createCheckoutSession: (token: string) =>
    client
      .post<{ checkout_url: string; session_id: string }>(
        `/portal/invoice/${token}/checkout-session`,
        {}
      )
      .then((r) => r.data),
};
